(() => {
  let scheduled = false;

  function repairSubscriptionLabels() {
    scheduled = false;

    document.querySelectorAll('label[for]').forEach((label) => {
      const targetId = label.getAttribute('for');
      if (!targetId || document.getElementById(targetId)) return;

      const labelText = label.textContent.trim().toLowerCase();
      let container = label.parentElement;
      let radio = null;

      for (let depth = 0; container && depth < 4; depth += 1, container = container.parentElement) {
        const containerText = container.textContent.toLowerCase();
        if (!labelText.includes('pay monthly') && !containerText.includes('subscription')) continue;

        const radios = container.querySelectorAll('input[type="radio"]:not([id])');
        if (radios.length === 1) {
          radio = radios[0];
          break;
        }
      }

      if (radio) radio.id = targetId;
    });
  }

  function scheduleRepair() {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(repairSubscriptionLabels);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleRepair, { once: true });
  } else {
    scheduleRepair();
  }

  new MutationObserver(scheduleRepair).observe(document.documentElement, {
    childList: true,
    subtree: true,
  });
})();
